module.exports = __webpack_public_path__ + "static/media/erp.a9d48cb1.jpg";